/**
 * AppSync Events channel paths: `{namespace}/{segment}/…` with no leading slash.
 * Matches AWS HTTP publish and Amplify `events.connect` examples
 * (e.g. `default/channel`, `documents/{caseId}/{userId}`).
 */
const DOCUMENTS_EVENT_NAMESPACE = "documents";

export const documentEventChannel = (caseId: string, userId: string): string =>
  `${DOCUMENTS_EVENT_NAMESPACE}/${caseId}/${userId}`;

/** Strip a leading slash so publish and subscribe use the same channel string. */
export const normalizeEventChannel = (channel: string): string => channel.replace(/^\/+/, "");
